import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import Typography from '@mui/material/Typography'
import "./css/AddnewItem.css"
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { Grid } from '@mui/material'
import NewTax from "./NewTax"
import axios from "axios"
import api from "../config/backend"

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}))

export default function ManageTax({ popup, setPopup, setTriggerRefresh, taxtype }) {
    const [addTaxPopup, setAddTaxPopup] = useState(false)
    const [taxList, setTaxList] = useState([])
    const [triggerTaxListRefresh, setTriggerTaxListRefresh] = useState(0)

    const token = localStorage.getItem("_crm__token")

    const fetchTaxList = async () => {
        const { data, status } = await axios.post(`${api}/Accounting/fetch-tax`, { 
            token, taxtype
        })

        if (data.success) {
            setTaxList(data.taxes)
        }
    }

    useEffect(() => {
        fetchTaxList()

        if (triggerTaxListRefresh) {
            setTriggerRefresh(prev => prev + 1)
        }
    }, [triggerTaxListRefresh, taxtype])

    return (
        <div className='Manage_tcs_dailog' >
            <BootstrapDialog
                onClose={() => setPopup(false)}
                aria-labelledby="customized-dialog-title"
                open={popup}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Manage {taxtype.toUpperCase()}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={() => setPopup(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Grid>
                        <NewTax 
                            taxtype={taxtype}
                            popup={addTaxPopup} 
                            setPopup={setAddTaxPopup} 
                            setTriggerTaxListRefresh={setTriggerTaxListRefresh}
                        />
                    </Grid>
                    <Grid>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell >Tax Name</TableCell>
                                        <TableCell align="right">Rate (%)</TableCell>
                                        <TableCell align="right">Nature of Collection</TableCell>
                                    </TableRow>
                                </TableHead>
                                {taxList.length ? <TableBody>
                                    {taxList.map((item, index) => {
                                        return (
                                            <TableRow key={index}>
                                                <TableCell align="right">{item.name}</TableCell>
                                                <TableCell align="right">{item.rate}</TableCell>
                                                <TableCell align="right">{item.tax.sectioncode} - {item.tax.section}</TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody> : undefined}
                            </Table>
                        </TableContainer>
                        {taxList.length ? undefined : <div className='taxes_show'>
                            No {taxtype.toUpperCase()} Taxes to show
                        </div>}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button className='btn-btn-save' autoFocus onClick={() => setPopup(false)}>
                        Save
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </div>
    )
}